'use strict';


angular.module('core')
	.factory('Utilities', ['VARIABLE_EXPRESSIONS', 'SweetAlert', '$modal', '$timeout', '$q', function(VARIABLE_EXPRESSIONS, SweetAlert, $modal, $timeout, $q) {
		var factory = {};

		factory._loadingModal = null;

		/**
		 * Displays a fullscreen loading modal which covers the whole screen
		 * @param action Either 'open' or 'close'
		 * @returns {null|*}
		 */
		factory.loadingUiModal = function(action) {
			var me = this;

			if (action === 'open') {
				if (me._loadingModal) {
					// Is already open
					return me._loadingModal;
				}

				// Has to get opened
				var opts = {
					keyboard: false,
					backdrop: false,
					templateUrl: 'modules/mobile-apps/views/loading-ui.client.view.html',
					windowTemplateUrl: 'modules/mobile-apps/views/fullscreen.client.directive.html'
				};

				me._loadingModal = $modal.open(opts);

				return me._loadingModal;
			} else if (action === 'close') {
				if (me._loadingModal !== null) {
					me._loadingModal.close();
					me._loadingModal = null;
				}
			}
		};


		/**
		 * Displays a modal which lets users upgrade their subscription to one
		 * that matches their requirements or it displays the owner information.
		 * What gets displayed depends if the current user is the team owner
		 * or not.
		 * @param exceededProperty The property which exceeds the current limit like "apps"
		 * @param teamOwner Team owner data
		 * @param currentUser Current user data
		 */
		factory.upgradeSubscriptionTeam = function(exceededProperty, teamOwner, currentUser, teamId, callback) {
			var me = this;

			if (teamOwner._id === currentUser._id) {
				// The current user is the team teamOwner so he can upgrade directly
				me.upgradeSubscriptionModal(exceededProperty, function(err, result) {
					if (err) {
						if (err === 'escape key press') {
							if (callback) {
								callback(null, false);
							}
							return;
						}

						me.showMessage(
							'Error!',
							'There was a problem updating your subscription. Please contact the support! Thanks!',
							'error'
						);

						if (callback) {
							callback(err);
						}
						return;
					}

					if (result === true) {
						// If user did upgrade the subscription refresh the
						// currently loaded data and display him a success message

						me.showMessage(
							'Success!',
							'You got successfully upgraded to a higher plan!',
							'success',
							function() {
								if (callback) {
									callback(null, true);
								}
							}
						);
					}
				});
			} else {
				// The current user is not the team owner so he has to
				// contact the teamOwner to upgrade
				me.upgradeSubscriptionNotOwnerModal(teamOwner, teamId, currentUser, exceededProperty, function(err, result) {
					if (err && err !== 'escape key press') {
						me.showMessage(
							'Error!',
							'There was a problem updating your subscription. Please contact the support! Thanks!',
							'error'
						);
						return;
					}

					if (callback) {
						callback(null, false);
					}
				});
			}

		};


		/**
		 * Displays a modal with the information of the team owner that the
		 * user can contact him that he upgrades
		 * @param owner The owner information
		 */
		factory.upgradeSubscriptionNotOwnerModal = function(owner, teamId, currentUser, exceededProperty, callback) {

			var modalInstance = $modal.open({
				templateUrl: 'modules/mobile-apps/views/upgrade-subscription-not-owner-modal.client.view.html',
				controller: 'UpgradeSubscriptionNotOwnerModalController',
				backdrop: 'static',
				size: 'md',
				resolve: {
					ModalData: function() {
						return {
							owner: owner,
							teamId: teamId,
							currentUser: currentUser,
							exceededProperty: exceededProperty
						};
					}
				}
			});

			modalInstance.result.then(function (result) {
				if (callback) {
					callback(null, result);
				}
			}, function(err) {
				// Something went wrong
				if (callback) {
					callback(err);
				}
			});
		};


		/**
		 * Displays a modal which lets users upgrade their subscription to one
		 * that matches their requirements
		 * @param exceededProperty The property which exceeds the current limit like "apps"
		 */
		factory.upgradeSubscriptionModal = function(exceededProperty, callback) {
			var modalInstance = $modal.open({
				templateUrl: 'modules/mobile-apps/views/upgrade-subscription-modal.client.view.html',
				controller: 'UpgradeSubscriptionModalController',
				backdrop: 'static',
				size: 'md',
				resolve: {
					ModalData: function() {
						return {
							exceededProperty: exceededProperty,
						};
					}
				}
			});

			modalInstance.result.then(function (result) {
				if (callback) {
					callback(null, result);
				}
			}, function(err) {
				// Something went wrong
				if (callback) {
					callback(err);
				}
			});
		};


		/**
		 * Displays a message to the user
		 * @param type The message type 'error', 'warning', 'info'
		 * @param title The title of the message to display
		 * @param message The message to display
		 * @param callback
		 */
		factory.showMessage = function(title, message, type, callback) {
			return $q(function(resolve, reject) {
				$timeout(function() {
					SweetAlert.swal(
						{
							title: title,
							text: message,
							html: true,
							type: type || 'info',
							showCancelButton: false
						},
						function (isConfirm) {
							if (callback) {
								callback();
							}
							if (isConfirm) {
								return resolve();
							}

							reject();
						}
					);
				}, 150);
			});
		};


		/**
		 * Displays the error message of the given error response to the user
		 */
		factory.showMessageErrorResponse = function(error) {
			// Get the error message to display
			var message = 'There was a problem';
			if (error && error.data && error.data.message) {
				message = error.data.message;
			} else if(error.statusText) {
				message = 'Received: "' + error.statusText + '"<br /> If this problem remains please contact our support!';
			}

			// Display the message to the user
			return factory.showMessage(
				'Error!',
				message,
				'error'
			);
		};


		return factory;
	}]);
